export default "__VITE_ASSET__CXKUgUOR__"